<div class="notifications">
  <a class="bell" #notiSpan (click)="onBellClick($event)">
    <i class="ri-notification-4-line"></i>
    <span class="notiCount" *ngIf="unReadCount > 0">{{ unReadCount }}</span>
  </a>
</div>

<p-overlayPanel styleClass="notificationfix" #notifyAll #op [style]="{ width: '400px'  }" [baseZIndex]="9999">
  <ng-template pTemplate="content">
    <div class="p-popover-wrapper">
      <div class="p-virtualscroller-header">
        <div class="row">
          <div class="col-6"><h6>Notifications</h6></div>
          <div class="col-6 text-right">
            <p-button label="Clear" icon="ri-delete-bin-line" styleClass="p-button-raised p-button-danger custom-clear-button"
              (onClick)="clearAllNotiffications()"></p-button>
          </div>
        </div>
      </div>

      <p-virtualScroller [items]="notificationList" *ngIf="notificationList.length > 0" scrollHeight="450px"
        [itemSize]="100">
        <ng-template let-notification pTemplate="item">
          <div class="flex align-items-center p-3 w-full flex-wrap" [class.unread]="!notification.read">
            <div class="flex-1" (click)="onNotificationClick(notification); op.hide()">
              <a [href]="notification.url"><span class="pi pi-link"></span></a>
              <p><b>{{ notification.title }}</b></p>
              <p>{{ notification.body }}</p>
              <p>Created By: {{ notification.initiatedBy.fullName }}</p>
              <p>Date: {{ notification.createdAt | prettyDate }}</p>
              <hr />
            </div>
          </div>
        </ng-template>
      </p-virtualScroller>

      <div *ngIf="notificationList.length === 0" class="p-3 text-center text-muted">
        No notifications found.
      </div>
    </div>
  </ng-template>
</p-overlayPanel>